import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { GNoValidation } from '../../../config/Validate';
import { APP_BASE_URL, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { DOWNLOAD_GNUMBERWISE_LIST, GET_RECEIPT_LIST } from '../../../config/ApiConstant';
import { DownloadReportListColumns } from '../../../appconfig/DatatableSetting';
import { dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { InputText } from 'primereact/inputtext';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const ReceiptDownload = () => {
    document.title = 'Receipt Download| GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const [regNo, setRegNo] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [reportsList, setReportsList] = useState<any>([]);
    const [userDetails, setUserDetails] = useState<any>({});
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <div className="input-effect-div">
                        <InputText value={regNo} name="RegNo" autoComplete="off" placeholder="Enter G Number" onChange={(e) => setRegNo(e.target.value)} className={errors['RegNo'] && 'p-invalid'} />
                        <span className="focus-bg"></span>
                    </div>

                    <small className="p-invalid-txt">{errors['RegNo']}</small>
                </div>

                <Button label="Show" onClick={() => getLetterDetails()} loading={showLoading} className="ml-3"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    //export CSv
    const exportCSV = async () => {
        try {
            const { errors, isError } = GNoValidation(regNo);
            setErrors(errors);
            if (!isError) {
                setExportLoader(true);
                const data = regNo.split(',');
                // Request Data
                const requestData = {
                    RegNoList: data
                };
                // Api Call
                const response = await postAllData(DOWNLOAD_GNUMBERWISE_LIST, requestData);

                if (response?.success) {
                    setExportLoader(false);

                    //CSV Download
                    const link = document.createElement('a');
                    link.href = APP_BASE_URL + '/csv/gnolist_details.csv';
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setExportLoader(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getLetterDetailsList
    const getLetterDetails = async () => {
        try {
            const { errors, isError } = GNoValidation(regNo);
            setErrors(errors);
            if (!isError) {
                setPageLoad(false);
                setShowLoading(true);

                // Request Data
                const requestData = {
                    search: regNo
                };

                const response = await postAllData(GET_RECEIPT_LIST, requestData);

                if (response) {
                    setPageLoad(true);
                    setShowLoading(false);
                    setReportsList(response?.data?.list);
                    setUserDetails(response?.data?.details);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    const fileTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions">
                    <Button icon="pi pi-file-pdf" onClick={() => linkOpen(rowData?.file_url)}>
                        {' '}
                    </Button>
                </div>
            </>
        );
    };

    const linkOpen = (url: any) => {
        window.open(url, '_blank');
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'Receipt Download'} pageTitle={'Receipt Download'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={reportsList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {DownloadReportListColumns.map((col: any, i: any) => {
                                        if (col.field === 'date') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'file_url') {
                                            return <Column key={col.field} header={col.header} body={fileTemplate} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {DownloadReportListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
